<article class="content-card {{view}}"
         [attr.data-test]="'card_lesson'"
         itemscope
         itemtype="https://schema.org/Article">

  <ng-container *ngTemplateOutlet="meta"></ng-container>

  <div class="card-cover" (click)="onOpenCardInModal()"></div>

  <div class="cover-wrap">
    <ng-container *ngTemplateOutlet="coverBlock"></ng-container>
    <div class="bookmark">
      <app-bookmark [notooltip]="true" [item]="content" [type]="'content'" (favoriteChanged)="favoriteChanged($event)"></app-bookmark>
    </div>
    <div class="stats">
      <ng-container *ngTemplateOutlet="statsTemplate"></ng-container>
    </div>
  </div>

  <div class="main-info-wrap">
    <div class="subject-wrap" [attr.data-test]="'card_lesson_subject'">
      <span class="subject">{{ subject }}</span>
    </div>
    <div class="title bold" [attr.data-test]="'card_lesson_title'">
      <a [href]="contentUrl" class="no-link">
        {{ content.title }}
      </a>
    </div>
    <div class="description">
      {{description | striptags}}
    </div>
    <div class="content-type-and-level normal" [attr.data-test]="'card_lesson_type'">
      {{ (contentTypeTitle | translate) + ', ' + (level | translate) }}
    </div>
    <ng-container *ngTemplateOutlet="authorInfo"></ng-container>
  </div>
</article>


<ng-template #meta>
  <meta itemscope itemprop="mainEntityOfPage" itemType="https://schema.org/WebPage" [attr.itemid]="contentUrl"/>

  <meta itemprop="url" content="{{ contentUrl }}"/>
  <meta itemprop="name" content="{{ fullTitle }}"/>
  <meta itemprop="datePublished" content="{{ contentDate?.toISOString() }}"/>
  <meta itemprop="image" content="{{ metaImageUrl || coverImageUrl }}"/>
  <!-- <meta *ngIf="description" itemprop="description" content="{{ description | striptags }}"/> -->
  <meta itemprop="headline" content=""/>
  <!-- <meta itemprop="publisher" content="htts://onclass.com"/> -->
  <!-- keywords -->
  <meta itemprop="inLanguage" content="{{ content.language?.code }}"/>
  <!-- discussionUrl -->
  <meta *ngIf="content.stats" itemprop="commentCount" content="{{ content.stats.comments_count }}"/>
</ng-template>

<ng-template #coverBlock>
  <div class="cover-block" [class.no-cover]="!cover">
      <on-ui-cover [cover]="cover" [scale]="doHover" [withBlur]="doBlur"
                   [attr.data-test]="'card_lesson_cover'"></on-ui-cover>
      <div *ngIf="isMediaTypeNecessary" class="type-content">
        <app-icon class="type-img-ico" [ngClass]="contentTypeUrl" [icon]="'type-' + contentTypeUrl"></app-icon>
      </div>
  </div>
</ng-template>

<ng-template #authorInfo>
  <div class="author-block" *ngIf="author">
    <div class="avatar-wrap">
      <on-ui-cover [cover]="authorAvatar" [attr.data-test]="'card_lesson_author_cover'"></on-ui-cover>
    </div>
    <div class="teacher-name"  [attr.data-test]="'card_lesson_author_name'">{{ authorName }}</div>
    <ng-container *ngTemplateOutlet="ratingWrap"></ng-container>
  </div>
</ng-template>

<ng-template #ratingWrap>
  <app-rating [stats]="authorStats"></app-rating>
</ng-template>

<ng-template #statsTemplate>
    <div class="details-left">
      <div class="item">
        <app-icon class="likes-icon" width="14" height="14" icon="thumb-up"
                  [class.active]="content.visit_info && content.visit_info.is_liked"></app-icon>
        <span [attr.data-test]="'lesson_card_likes'">{{ content.stats.likes_count }}</span>
      </div>

      <div class="item">
        <app-icon class="dislikes-icon" width="14" height="14" icon="thumb-down"
                  [class.active]="content.visit_info && content.visit_info.is_disliked"></app-icon>
        <span [attr.data-test]="'lesson_card_dislikes'">{{ content.stats.dislikes_count }}</span>
      </div>
    </div>
    <div class="details-right">
      <div class="item">
        <app-icon class="views-icon" width="14" height="14" icon="shows"
                  [class.active]="content.visit_info && content.visit_info.is_viewed"></app-icon>
        <span [attr.data-test]="'lesson_card_views'">{{ content.stats.views_count }}</span>
      </div>
    </div>
</ng-template>
